import { API_ENDPOINT, COMPANY_LOGO_ENDPOINT } from '@/config/endpoint';
import { Collapse, Flex, Tabs, Text } from '@mantine/core';
import { addRefParam, emojiSource, isDark } from '@/utils/utils';

import Card from '@/components/Card';
import Image from 'next/image';
import MenuItem from '@/components/MenuItem';
import { lastClickedTechblog } from '../techblog.state';
import themeVariables from '@/styles/themeVariables';
import { useGetTechblogRanking } from '../hook/api';
import { useSetAtom } from 'jotai';
import { useTechblogListPageSideBoxStyle } from '../techblog.style';

const TechblogRanking = () => {
  const { dark } = isDark();
  const { classes } = useTechblogListPageSideBoxStyle({ dark });

  const { data } = useGetTechblogRanking();
  const setLastClickTechblog = useSetAtom(lastClickedTechblog);

  const handleCardClick = (techblog) => {
    API_ENDPOINT.techblog.viewcount(techblog.id);
    API_ENDPOINT.viewcount.increaseTechblog(techblog.id);
    setLastClickTechblog({
      id: techblog.id,
      companyId: techblog.company_id,
      title: techblog.title,
      date: techblog.published,
    });
    window.open(addRefParam(techblog.link), '_blank');
  };

  return (
    <Card noShadow>
      <div className={classes.cardContainer}>
        <div className={classes.headerContainer}>
          <Flex gap={15} align={'center'}>
            <Image
              width={24}
              height={24}
              src={emojiSource('1f525', 'apple')}
              alt="emoji"
            />
            <Text className={classes.headerTitle}>가장 많이 읽은 글</Text>
          </Flex>
        </div>
        <Collapse in={true} transitionDuration={400}>
          <div className={classes.popularRankingListContainer}>
            <Tabs variant={'pills'} defaultValue={'weekly'}>
              <Tabs.List className={classes.tabContainer}>
                <Tabs.Tab className={classes.tab} value={'weekly'}>
                  최근 7일
                </Tabs.Tab>
                <Tabs.Tab className={classes.tab} value={'monthly'}>
                  최근 1달
                </Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value={'weekly'}>
                {data?.weekly &&
                  data?.weekly.slice(0, 5).map((techblog, index) => (
                    <MenuItem
                      key={index}
                      leftElement={
                        <Image
                          width={32}
                          height={32}
                          src={`${COMPANY_LOGO_ENDPOINT}/${techblog.company_id}.png`}
                          style={{ backgroundColor: '#fff' }}
                          alt="logo"
                        />
                      }
                      rightElement={
                        <Text
                          size={14}
                          color={
                            dark
                              ? themeVariables.label.normalDark
                              : themeVariables.fontColors.medium
                          }
                          lineClamp={2}
                        >
                          {techblog?.title}
                        </Text>
                      }
                      techstackIds={(techblog?.tag || '').split(',')}
                      onClick={() => handleCardClick(techblog)}
                    />
                  ))}
              </Tabs.Panel>
              <Tabs.Panel value={'monthly'}>
                {data?.monthly &&
                  data?.monthly.slice(0, 5).map((techblog, index) => (
                    <MenuItem
                      key={index}
                      leftElement={
                        <Image
                          width={32}
                          height={32}
                          src={`${COMPANY_LOGO_ENDPOINT}/${techblog.company_id}.png`}
                          style={{ backgroundColor: '#fff' }}
                          alt="logo"
                        />
                      }
                      rightElement={
                        <Text
                          lineClamp={2}
                          size={14}
                          color={
                            dark
                              ? themeVariables.label.normalDark
                              : themeVariables.label.normal
                          }
                        >
                          {techblog.title}
                        </Text>
                      }
                      techstackIds={(techblog?.tag || '').split(',')}
                      onClick={() => handleCardClick(techblog)}
                    />
                  ))}
              </Tabs.Panel>
            </Tabs>
          </div>
        </Collapse>
      </div>
    </Card>
  );
};

export default TechblogRanking;
